module.exports = __webpack_public_path__ + "34fa213012437c1fe485fbeb33cd6665.png";